<template>
  <div>
    <b-modal
      hide-footer
      id="modalParticipantes"
      centered
      title="Lista de Presença"
    >
      <form @submit.prevent="submit" ref="addPresenca">
        <div class="row">
          <div class="col-md-12">
            <b-list-group>
              <b-list-group-item
                v-on="addDados(participantesPresentes)"
                class="border"
                v-for="(key, index) in participantes"
                :key="participantes[index]['id']"
              >
                <input
                  type="checkbox"
                  :id="participantes[index]['nome']"
                  :value="participantes[index]['id']"
                  name="presenca"
                  v-model="dados"
                />

                <label :for="participantes[index]['nome']">
                  {{ participantes[index]["nome"] }}
                </label>
              </b-list-group-item>
            </b-list-group>
          </div>
          <div class="col-md-12 text-right">
            <button
              class="btn btn-success btn-submit-modal mt-3"
              data-style="zoom-in"
              type="submit"
            >
              <i class="mdi mdi-content-save" />
              {{ $t("Confirmar Presenças") }}
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["model", "modelId"],
  name: "ModalPresencaParticipantes",
  props: {
    participantes: Array,
    participantesPresentes: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      dados: [],
    };
  },
  watch: {
    dados(newValue) {
      this.$emit("presentes", newValue);
    },
  },
  methods: {
    addDados(participantes) {
      this.dados = participantes;
    },
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-submit-modal"));
      ladda.start();

      let dados = {
        id: this.$route.params.id,
        presenca: this.dados,
      };

      if (this.$attrs.model == "ScfvGrupo") {
        dados.id = this.$attrs.modelId;
      }

      axios
        .post(`api/dashboard/update/participantes/atividades`, dados)
        .then((response) => {
          ladda.stop();
          this.$bvModal.hide("modalParticipantes");
          this.addDados(this.participantesPresentes);
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .catch((e) => {
          this.$snack.success({
            button: false,
            text: e,
          });
          ladda.stop();
        });
    },
  },
};
</script>
